import { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import {
  Typography,
  Grid,
  Box,
  FormGroup,
  FormControlLabel,
  Switch,
} from '@material-ui/core';
import { CanvasRead, ValueCanvasRead } from '../../CreateIdeaDialogs';
import { IdeaApproverTable } from '../..';
import { MenuInformation } from '../../Shared';
import { ideaActions } from '../../../actions';
import { IdeaCss } from '../IdeaCss';
import {IdeaInfo} from './IdeaInfo';
import {IdeaDetails} from './IdeaDetails';
import {IdeaCanvas} from './IdeaCanvas';
import {IdeaContributors} from './IdeaContributors';
import {IdeaFinancialReturn} from './IdeaFinancialReturn';
import {IdeaAttachments} from './IdeaAttachments';
import {IdeaBusinessUnitLocal} from './IdeaBusinessUnitLocal';

export function IdeaGeneral() {
  const classes = IdeaCss();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isOpenCanvas, setIsOpenCanvas] = useState(false);
  const [isOpenValueCanvas, setIsOpenValueCanvas] = useState(false);
  const user = useSelector(state => state.user);
  const { ideaDetailsFlux } = useSelector(state => state.fluxIdeas);

  function handleOnOpenValueCanvas() {
    setIsOpenValueCanvas(true)
  }

  function handleOnCloseValueCanvas() {
    setIsOpenValueCanvas(false)
  }

  function handleOnOpenCanvas() {
    setIsOpenCanvas(true)
  }

  function handleOnCloseCanvas() {
    setIsOpenCanvas(false)
  }

  function handleChange(status) {
    dispatch(ideaActions.sendTimelineView(ideaDetailsFlux._id, status));
  }

  function isFillCanvas(canvas) {
    if (!!canvas.length) {
      const hasAnswer = canvas.map((item) => item.answer?.length).some((length) => length > 0);
      return hasAnswer;
    };
    return false
  };

  return (
    <>
      <CanvasRead idea={ideaDetailsFlux} isOpen={isOpenCanvas} onClose={handleOnCloseCanvas} />
      <ValueCanvasRead idea={ideaDetailsFlux} isOpen={isOpenValueCanvas} onClose={handleOnCloseValueCanvas} />

      <Grid container spacing={2}>
        <IdeaInfo />

        <Grid item xs={12} sm={4} md={4} lg={4}>
          <Grid container spacing={2}>
            <IdeaDetails />

            {(isFillCanvas(ideaDetailsFlux.canvas) || isFillCanvas(ideaDetailsFlux.canvasValueProposition)) && (
              <IdeaCanvas
                handleOnOpenValueCanvas={handleOnOpenValueCanvas}
                handleOnOpenCanvas={handleOnOpenCanvas}
              />
            )}

            {ideaDetailsFlux.contributors?.length > 0 && <IdeaContributors />}
          </Grid>
        </Grid>
        
        {(ideaDetailsFlux?.estimatedExecutionCost > 0 || ideaDetailsFlux?.estimatedFinancialReturn > 0) && <IdeaFinancialReturn />}

        {(ideaDetailsFlux.links?.length > 0 || ideaDetailsFlux.attachments?.length > 0) && <IdeaAttachments />}

        {ideaDetailsFlux?.businessUnitLocal?.map(item => item)[0] && <IdeaBusinessUnitLocal />}

        {ideaDetailsFlux?.currentStepFlux?.evaluatorsInStep?.length > 0 && (
          <>
            <Grid item xs={12}>
              <Box display="flex" alignItems="center">
                <Typography className={classes.titleUpperCase}>
                  {t('qualificadores_atribuidos')}
                </Typography>
                <MenuInformation>
                  {t('possiveis_qualificadores_para_essa_ideia_sao_os_gestores_da_area_de_abrangencia_vinculada')}
                </MenuInformation>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <IdeaApproverTable />
            </Grid>
          </>
        )}

        {['admin', 'manager'].includes(user.typeProfile.type) && 
         ideaDetailsFlux?.statusIdea?.code !== "AWAITING_QUALIFICATION" && (
          <Grid item xs={12}>
            <FormGroup>
              <FormControlLabel
                label={t('exibir_ideia_no_feed')}
                control={
                  <Switch
                    color="primary"
                    checked={ideaDetailsFlux?.timeline}
                    onChange={() => handleChange(!ideaDetailsFlux?.timeline)}
                  />
                }
              />
            </FormGroup>
          </Grid>
        )}
      </Grid>
    </>
  );
}